import React from 'react';
import { Card, CardDeck, Image, ProgressBar } from 'react-bootstrap';
import Scrollspy from 'react-scrollspy';
import ReactMarkdown from 'react-markdown'
import { useTranslation } from "react-i18next";

import * as Icon from 'react-bootstrap-icons';

import elementsofei from "../images/elements-of-ei.png";
import oceanandei from "../images/ocean-and-ei.png";
import oceanwave from "../images/ocean-wave.png";
import nurturinggrowth from "../images/nurturing-growth.jpg";
import heartheadhandshake from "../images/heart-head-handshake.jpg";
import reflectionimg from "../images/reflection.jpg";
import christraits from "../images/chris-ocean-traits.png";
import teamworkimg from "../images/teamwork.png";
import groupoffriends from "../images/group-of-friends.jpg";
import ecourseimg from "../images/e-course.jpg";
import meyouus from "../images/me-you-us.png";
import friendshipimg from "../images/friendship.jpg";
import elementsoftrust from "../images/likability-expertise-reliability.png";
import studyingmaterials from "../images/studying-materials.jpg";
import problemsolving from "../images/problem-solving.png";
import dilemmaimg from "../images/dilemma.jpg";
import analyticsimg from "../images/analytics.jpg";
import paretoprincipleimg from "../images/pareto-principle.png";
import communicationimg from "../images/communication.jpg";
import leadershipimg from "../images/leadership.png";
import raisedhandsimg from "../images/raised-hands.jpg";
import fingerprintsimg from "../images/researcher.jpg";
import likabilityexpertisereliability from "../images/likability-expertise-reliability.png";
import expertiseimg from "../images/expertise.jpg";
import growthimg from "../images/growth.jpg";
import climbingimg from "../images/climbing.jpg";
import batteryimg from "../images/battery.jpg";
import feedbackimg from "../images/feedback.jpg";
import ovaluesimg from "../images/o-values.png";
import maslowpyramid1img from "../images/maslow-pyramid-1.png";
import emotionalityimg from "../images/emotionality.png";
import warmthimg from "../images/warmth.jpg";
import fivebehaviorsimg from "../images/five-behaviors-1.png";
import feelingvaluedimg from "../images/feeling-valued.png";
import yourratingstheirratingsimg from "../images/your-ratings-their-ratings.png";
import {questionsApi} from "../api/_360_questions";
import i18n from "i18next";

function percent(item){
	return 100*(item/7);
}

const ReportPBar = (props) => {
	return <div><section className="progress-width mb-5">
		<ProgressBar className="my-2 my-rating" now={percent(props.results.user[props.category])} label={props.results.user[props.category]} />
		<ProgressBar className="my-2 their-rating" now={percent(props.results.feedback[props.category])} label={props.results.feedback[props.category]} />
	</section>
		<div className="myimghor my-0">
			<img src={yourratingstheirratingsimg} alt="Your ratings and their ratings" />
		</div>
	</div>
}
const ReportTopItem = (props) => {
	return (<div><p><a href={`#section-${props.num}`} className="important-link">{props.num-1}. {props.category} <Icon.ArrowRight className="ml-2" /></a></p>
		<ReportPBar results={props.results} category={props.category} num={props.num} />
	</div>)
}

function getQuestionLabel(questionId){
	return questionsApi[i18n.language].filter( q => q['id'] == questionId)[0]['userQuestion'];
}

function IndividualQuestionFeedback(props: { questionId: string, number: number, feedbackByQuestion: any }) {
	return (
		<div><h5>{props.number}. {getQuestionLabel(props.questionId)}</h5>
			{props.feedbackByQuestion[props.questionId]?
				(<div><section className="progress-width">
					<ProgressBar className="my-2 my-rating" now={percent(props.feedbackByQuestion[props.questionId].user)} label={props.feedbackByQuestion[props.questionId].user} />
					{props.feedbackByQuestion[props.questionId].count < 2 ? <ProgressBar striped={true} animated={true} className="my-2 their-rating" now={100} label={'not enough results'} aria-disabled={true} /> :
					<ProgressBar className="my-2 their-rating" now={percent(props.feedbackByQuestion[props.questionId].average)} label={props.feedbackByQuestion[props.questionId].average} />}
				</section>
				<div className="myimghor my-0">
					<img src={yourratingstheirratingsimg} alt="Your ratings and their ratings" />
				</div></div>)
				: <div/>
			}
		</div>);
}

const shbw = (user:number, feedback:number) => {
	const threshold = 5;
	if (user >= threshold && feedback >= threshold){
		return "Strength";
	}
	if (user >= threshold && feedback < threshold){
		return "Blind spot";
	}
	if (user < threshold && feedback >= threshold){
		return "Hidden strength";
	}
	if (user < threshold && feedback < threshold){
		return "Weakness";
	}
	return "Unknown";
}

function SkillResult(props: { category: string, results: any}) {
	const {i18n} = useTranslation();
	const level:string = shbw(props.results.user[props.category],props.results.feedback[props.category])
	return <div>
		<h5>Your {props.category} skills are a {i18n.t(level)}</h5>
		<h5>{i18n.t(level+'.desc')}</h5>
	</div>
}

function ThreeSixtyFeedbackContent(props: any) {
    const {i18n} = useTranslation();
	const categories = [
		'Problem-solving',
		'Teamwork',
		'Strong work ethics',
		'Analytical Thinking',
		'Communication',
		'Leadership',
		'Initiative',
		'Thoroughness',
		'Expertise',
		'Growth Mindset',
		'Drive for results',
		'Energy management',
		'Openness to feedback',
		'Purpose',
		'Emotional poise',
		'Trust building'
	];
	function topItem(results, category,num){
		return <ReportTopItem results={results} category={category} num={num} />
	}


  return (
   	<div>
		<body className="masthead" data-spy="scroll" data-offset="60" data-target="#myNavbar">

			<Scrollspy items={ ['send-invites','section-1', 'section-2', 'section-3', 'section-4', 'section-5', 'section-6', 'section-7', 'section-8', 'section-9', 'section-10', 'section-11', 'section-12', 'section-13', 'section-14', 'section-15', 'section-16', 'section-17', 'section-18' ] } currentClassName="is-current" className="sticky-top scrollspy overflow-scroll-horizontal" offset={20}>
				<li><a href="#send-invites" className="scrollspy-link">back to emails</a></li>
				<li><a href="#section-1" className="scrollspy-link">Top</a></li>
				<li><a href="#section-2" className="scrollspy-link">1. Problem-solving</a></li>
				<li><a href="#section-3" className="scrollspy-link">2. Teamwork</a></li>
				<li><a href="#section-4" className="scrollspy-link">3. Work ethic</a></li>
				<li><a href="#section-5" className="scrollspy-link">4. Analytical skills</a></li>
				<li><a href="#section-6" className="scrollspy-link">5. Communication</a></li>
				<li><a href="#section-7" className="scrollspy-link">6. Leadership</a></li>
				<li><a href="#section-8" className="scrollspy-link">7. Initiative</a></li>
				<li><a href="#section-9" className="scrollspy-link">8. Thoroughness</a></li>
				<li><a href="#section-10" className="scrollspy-link">9. Expertise</a></li>
				<li><a href="#section-11" className="scrollspy-link">10. Growth Mindset</a></li>
				<li><a href="#section-12" className="scrollspy-link">11. Drive for Results</a></li>
				<li><a href="#section-13" className="scrollspy-link">12. Energy Management</a></li>
				<li><a href="#section-14" className="scrollspy-link">13. Openness to Feedback</a></li>
				<li><a href="#section-15" className="scrollspy-link">14. Purpose-Orientation</a></li>
				<li><a href="#section-16" className="scrollspy-link">15. Emotional Poise</a></li>
				<li><a href="#section-17" className="scrollspy-link">16. Trust-Building</a></li>
			</Scrollspy>

			<section id="section-1">
				<div className="myimghor">
					<img src={feedbackimg} alt="People talking to each other" />
				</div>
				<h1>Your 360 Degree Feedback</h1>
				

				<div className="quote">
					<span className="quotation-mark"></span>
					<p className="quote-citation"><i>Constructive, critical feedback is one of the rarest thing to get in a business setting.</i></p>
					<p className="quote-source"><b> &mdash; John Doerr</b></p>
				</div>

				<span className="quotation-mark"></span>
					<p className="quote-citation"><i>Constructive, critical feedback is one of the rarest thing to get in a business setting.</i></p>
					<p className="quote-source"><b> &mdash; John Doerr</b></p>

				<p><b>Number of feedbacks requested {props.totalSent}</b></p>
				<p><b>Number of feedbacks received {props.responsesSoFar}</b></p>


				<h2>Your 16 Skills At a Glance</h2>
				<div className="myimghor">
					<img src={yourratingstheirratingsimg} alt="Your ratings and their ratings" />
				</div>
				{categories.map((value, index) => topItem(props.results,value,index+2))}
			</section>


			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-2" className="offset-anchor">
				<div className="myimghor">
					<img src={problemsolving} alt="People solving problems" />
				</div>


				<h2>1. Your Problem-Solving Skills</h2>

				<ReportPBar results={props.results} category={'Problem-solving'} num={1}/>

				<SkillResult category={'Problem-solving'} results={props.results}/>

				<h3>What is Problem-Solving?</h3>
				<ReactMarkdown>Problem-solving describes your ability to understand the root cause of a problem, how to correct it and how to prevent it from reoccurring.</ReactMarkdown>
				<ReactMarkdown>Solving problems requires going through 6 steps:</ReactMarkdown>

				<ol>
					<li>Defining the problem</li>
					<li>Identifying its root cause</li>
					<li>Brainstorming potential solutions</li>
					<li>Evaluating solutions</li>
					<li>Implementing the chosen solution</li>
					<li>Assessing the solution's effectiveness (post-mortem)</li>
				</ol>

				<h4>Feedback on your 3 problem-solving answers</h4>
				<IndividualQuestionFeedback number={1} questionId={'bb3dd9a1-a3ff-48e3-8578-8e793874b6b8'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h5>Why it matters</h5>
				<ReactMarkdown>While problems are inevitable in life and at work, not all problems are created equal. Some have more dire consequences than others, while others are difficult to understand. </ReactMarkdown>
				<ReactMarkdown>However, searching for the root cause of a problem is key in both solving it and preventing it from occurring again. All three activities are key if you want to become an expert at solving problems.</ReactMarkdown>

				
				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'863e0bdc-8c6e-42b6-b271-170051419294'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h5>Why it matters</h5>
				<ReactMarkdown>Accurately defining your problem is key, because if you don’t define the right problem, you will likely solve the wrong problem. Here is an example: </ReactMarkdown>
				
				<div className="story my-3">
					<ReactMarkdown>Your company’s profits have fallen dramatically in the last 12 months. What should you do?  </ReactMarkdown>
				</div>
				
				<ReactMarkdown>By taking enough time to research the root cause of your problem – the fact that your revenues have plateaued while your costs have exploded over the same time period – you will not realize that the question you need to answer is: How can I reduce my costs?</ReactMarkdown>
				<ReactMarkdown>If you only focused on the revenue portion of the profitability equation, you may not have been able to solve your problem, while changing your cost structure would more quickly bring you back to breakeven.</ReactMarkdown>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'7c07dab7-934b-4f82-8d0b-8e617280072f'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h5>Why it matters</h5>
				<ReactMarkdown>**Opinions are dangerous, because you are more likely going to be wrong than lucky.** Facts and data on the other hand, point to a more objective and realistic understanding of your situation. Therefore, they are a better leg to stand on than opinions are. If you have an idea, you can test its validity by searching for facts that will prove or disprove it.</ReactMarkdown>
				
				<h4>How you can grow your problem-solving skills</h4>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>

				<div className="separator-large" />
			</section>
			

			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-3" className="offset-anchor">
				<div className="myimghor">
					<img src={teamworkimg} alt="People helping each other" />
				</div>

				<h2>2. Your Teamwork Skills</h2>

				<ReportPBar results={props.results} category={'Teamwork'} num={2}/>

				<SkillResult category={'Teamwork'} results={props.results}/>

				<h3>What are teamwork skills?</h3>
				<ReactMarkdown>Teamwork describes your ability to work with others, anticipate and meet their demands to achieve a common objective.</ReactMarkdown>
				<ReactMarkdown>Teamwork means you have the interests of the team at heart, rather than solely focusing on your own. The collective performance of the team is what truly matters. If your individual contribution is good, yet you don’t assist the rest of the team when it struggles, your teamwork is poor.</ReactMarkdown>
				<ReactMarkdown>Teamwork requires that you:</ReactMarkdown>

				<ol>
					<li>Share a common vision of the future with the rest of the team</li>
					<li>Are willing to help when needed</li>
					<li>Do your best and keep others accountable for doing their best</li>
					<li>Engage in constructive conversations about the challenges at hand, rather than in destructive conversations about the people.</li>
				</ol>

				<h4>Feedback on your 3 teamwork answers</h4>
				<IndividualQuestionFeedback number={1} questionId={'2b3888d8-b5f4-4b60-9901-d33b3f3b76db'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h5>Why it matters</h5>
				<ReactMarkdown>Receiving praise and encouragements is a key motivator for many people. How did you feel when you worked hard on a project and did not receive any praise or encouragement along the way?</ReactMarkdown>
				
				<div className="quote">
					<p><i>"Never discourage anyone who continually makes progress, no matter how slow."</i></p>
					<p><b>Plato</b></p>
				</div>
				
				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'e77e6a6b-a4d6-48e7-b0f4-a71b2933f15c'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h5>Why it matters</h5>
				<ReactMarkdown>**You don’t have to do everything yourself to be a great team player.** When someone asks you a question and you connect them with another person who will likely be able to help them out, you are still helping the team without sacrificing too much of your precious time and energy.</ReactMarkdown>

				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'fb6ab099-d18a-4f22-9088-903abbc263c6'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h5>Why it matters</h5>
				<ReactMarkdown>**Being a good individual contributor is not sufficient to become a great team player.** You have to be willing to go beyond your roles and responsibilities and help your teammates when they need you.</ReactMarkdown>

				<section className="course-tables-center mt-4">
					<Card className="hover-increase" style={{ width: '18rem' }}>
						<Card.Img as={Image} src={likabilityexpertisereliability} variant="top" className="mb-3" />
						<Card.Title className="m-3">What are the 3 elements of trust?<Icon.ArrowRight className="ml-2" /></Card.Title>
						<a href="/elements-of-trust" className="stretched-link"></a>
					</Card>
				</section>


				<h4>How you can grow your teamwork skills</h4>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>


			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-4" className="offset-anchor">

				<div className="myimghor">
					<img src={dilemmaimg} alt="Person facing a dilemma" />
				</div>

				<h2>3. Your Strong Work Ethic</h2>

				<ReportPBar results={props.results} category={'Strong work ethics'} num={3}/>

				<SkillResult category={'Strong work ethics'} results={props.results}/>

				<h3>What is a strong work ethic?</h3>
				<ReactMarkdown>**A strong work ethic describes how morally you behave at work.** Going the extra mile is not enough, because how you interact with others may affect morale and, therefore, the collective performance of the team.</ReactMarkdown>

				<h3>Feedback on your 3 strong work ethic answers</h3>

				<IndividualQuestionFeedback number={3} questionId={'3aeaae3f-8a95-4b41-81de-780fc96c333b'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Focusing on short-term results - such as meeting the analysts’ quarterly arbitrary predictions at all costs - leads to cutthroat working environments, unethical behavior, and mass layoffs. When we put the numbers before the people, everyone suffers, including the numbers we are trying to reach.</ReactMarkdown>
				<ReactMarkdown>There are many usual suspects to cutting corners: </ReactMarkdown>
				
				<ul>
					<li>Reduce investments in R&D</li>
					<li>Regularly laying off people</li>
					<li>Using cheaper materials resulting in lower quality</li>
					<li>Growing through acquisitions without seeking to harmonize the two organizations</li>
				</ul>

				<ReactMarkdown>This obsession with beating the competition and winning at all costs has devastating results:</ReactMarkdown>
 
				<ol>
					<li>People start to realize they are not safe from being laid off at any time for arbitrary reasons</li>
					<li>This forces them to stop trusting their coworkers, leaders, and organizations</li>
					<li>They then start engaging in self-preserving behaviors, such as hoarding information, hiding mistakes and avoiding risk taking</li>
					<li>As a result, teamwork starts to suffer, and so does innovation and the company’s performance, which exacerbates the problem.</li>
				</ol>

				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'86c6f04a-b0a3-4d49-a6fc-af52869dda83'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>In *Good to Great*, Jim Collins wrote about **Level 5 leaders, people who demonstrate both extreme personal humility and an intense professional will.** They want their people and their organizations to persevere and to thrive, without putting themselves in the spotlight by taking undue credit. </ReactMarkdown>
				<ReactMarkdown>By doing so, they enabled their people to do the right things and to resist the temptation to put their personal interests ahead of the interests of the team and the organization. This, as a result, made them more resilient and led to far greater performance which did not decline over time.</ReactMarkdown>
				<ReactMarkdown>One behavior that these rare leaders demonstrated was called by Collins “the window and the mirror”:</ReactMarkdown>

				<ul>
					<li>They looked out of the window for successes, giving their partners more credit for achievements.</li>
					<li>They looked in the mirror for responsibility, looking for their accountability when things went wrong and seeking to understand how they can grow from their setbacks.</li>
				</ul>

				<div className="notabene">
					<ReactMarkdown>In other words, **they gave away all the credit when things went well and took all the responsibility when things went wrong.** They were tough on themselves and generous with others.</ReactMarkdown>
				</div>
				
				<ReactMarkdown>In contrast, leaders who did not manage to achieve the transition from good to great organizations demonstrated the opposite tendencies:</ReactMarkdown>

				<ul>
					<li>They looked out of the window for responsibility, searching for people and events they could blame to explain why their brilliant plans did not work.</li>
					<li>They looked in the mirror for successes, claiming excessive credit for achievements.</li>
				</ul>

				<div className="notabene">
					<ReactMarkdown>In other words, they took all the credit when things went well and passed the blame on everyone and everything else when things went wrong. They were generous with themselves and tough on others.</ReactMarkdown>
				</div>

				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'e77e6a6b-a4d6-48e7-b0f4-a71b2933f15c'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>In the first century, in ancient Rome, there was already a saying, *“errare humanum est, persevare diabolicum”*, which means, *“to err is human, but to persist (in your mistake) is diabolical”*. Humans are fallible and imperfect beings, and that is okay. Making mistakes is unavoidable and can bring with it much learning. </ReactMarkdown>
				<ReactMarkdown>What the Romans considered to be unacceptable was to persist when you knew that what you were doing was wrong, therefore not learning from your mistakes and changing your behavior. Perseverance is a wonderful human quality, as long as it aims towards the sky, for the improvement of humankind. Persisting in your mistakes, however, is the path towards misery and despair. </ReactMarkdown>
				<ReactMarkdown>Trying to correct your mistakes, to right your wrongs, is a great way of taking responsibility for your actions and your mistakes. When others see you admit your mistakes and try to correct them, they will perceive you as someone who they can trust. </ReactMarkdown>
				
				<div className="quote">
					<p><i>"I never stopped trying to become qualified for the job."</i></p>
					<p><b>Darwin Smith, Former CEO of Kimberly-Clark</b></p>
				</div>

				<h3>How you can grow your work ethic</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>


			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-5" className="offset-anchor">
				<div className="myimghor">
					<img src={analyticsimg} alt="Group of friends together" />
				</div>

				<h2>4. Your Analytical Skills</h2>

				<ReportPBar results={props.results} category={'Analytical Thinking'} num={4}/>

				<SkillResult category={'Analytical Thinking'} results={props.results}/>

				<h3>What are analytical skills?</h3>
				<ReactMarkdown>Analytical skills describe **your ability to collect and analyze information, draw insightful conclusions from them, and use the latter to facilitate the decision-making process.**</ReactMarkdown>
				<ReactMarkdown>Here are some examples which involve having analytical skills:</ReactMarkdown>
				
				<ul>
					<li>Brainstorming</li>
					<li>Finding patterns</li>
					<li>Interpretating data</li>
					<li>Integrating new information into existing knowledge and practices</li>
					<li>Evaluating alternatives</li>
					<li>Reporting your findings to make a change happen</li>
				</ul>

				<h3>Feedback on your 3 analytical skills answers</h3>

				<IndividualQuestionFeedback number={1} questionId={'887fb4f0-74ef-491a-8abb-b3686d04de9b'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Tackling one gigantic problem may sometimes feel overwhelming, if not impossible. By breaking down said problem into smaller parts, you make the problem-solving process easier.</ReactMarkdown>
				<ReactMarkdown>Why? Because you can more easily identify their root causes and therefore generate and evaluate alternative ways of solving these components.</ReactMarkdown>
				<ReactMarkdown>Moreover, not all components are born equal. Some deliver a lot of benefits by solving them, while others don’t. Your ability to distinguish the critical few from the trivial many enables you to focus the smallest amount of energy while generating the biggest benefits from your efforts. This is known as the Pareto principle, or the 80/20 rule, where 20% of your efforts bring 80% of the benefits.</ReactMarkdown>

				<div className="myimghor">
					<img src={paretoprincipleimg} alt="Group of friends together" />
				</div>

				<div className="imgcaption">
					The Pareto Principle
				</div>

				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'f937b297-349e-4ce0-897a-f00bf60f9105'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Connecting the dots between what first appear to be unrelated issues is a great way to solve a problem and prevent it from reoccurring. Indeed, when you find a correlation between a cause and its consequences, you will likely be better able at taking preventive and corrective actions.</ReactMarkdown>
				<ReactMarkdown>This also allows you to anticipate obstacles, where your actions today may have problematic consequences tomorrow, next week, next month or next year. By assessing risks, you increase the likelihood of progressing while minimizing the potential damages.</ReactMarkdown>
				<ReactMarkdown>Finally, considering different approaches prevents you from getting stuck in a binary approach, where your only alternatives are “doing A versus not doing A”. Evaluating different alternatives will enable you to test what seems like the best approach, evaluate its benefits and drawbacks, and decide whether you should try another approach or not.</ReactMarkdown>

				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'cdc02e6c-ace4-4361-9692-b3c7b51a3c0e'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>If people don’t understand what you say, they will not trust your advice. Regardless of how important your findings are, if no one can understand what they mean and how they may impact their worlds and their work, they are unlikely going to act in a way which will be beneficial for them or you.</ReactMarkdown>
				<ReactMarkdown>To make a change happen, people need to be able to understand why your insights matter, what they mean, and how they can benefit from changing their behavior.</ReactMarkdown>
				
				<h3>How you can grow your analytical skills</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>


			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-6" className="offset-anchor">
				<div className="myimghor">
					<img src={communicationimg} alt="People talking to each other" />
				</div>

				<h2>5. Your Communication Skills</h2>

				<ReportPBar results={props.results} category={'Communication'} num={5}/>

				<SkillResult category={'Communication'} results={props.results}/>
				<h3>What are communication skills?</h3>
				
				<div className="quote">
					<p><i>"Communication skills allow you to understand and be understood by others."</i></p>
					<p><b>Indeed</b></p>
				</div>
				
				<ReactMarkdown>Communication is a two-way process, which involves sending and receiving information. Whether you are sending or receiving information, your goal is to maximize understanding. Ask clarifying questions and make sure you both have the same understanding of the situation.</ReactMarkdown>
				<ReactMarkdown>Communication skills involve:</ReactMarkdown>

				<ul>
					<li>Listening</li>
					<li>Speaking</li>
					<li>Reading</li>
					<li>Writing</li>
					<li>Observing</li>
					<li>Empathizing</li>
					<li>Understanding</li>
				</ul>

				<ReactMarkdown>By helping you understand and be understood by others, communication will help you to nurture your personal and professional relationships. This the 4th element of emotional intelligence, relationships development.</ReactMarkdown>
				<ReactMarkdown>If people don’t understand what you need from them, why they should care, or how they should proceed, they will not be willing or able to help you. This may lead to unnecessary conflicts caused by simple misunderstandings and lack of clarity.</ReactMarkdown>
 
				<div className="quote">
					<p><i>"Between:</i></p>
					<ol><i>
						<li>What I think,</li>
						<li>What I want to say,</li>
						<li>What I believe I say,</li>
						<li>What I say,</li>
						<li>What you want to hear,</li>
						<li>What you believe to hear,</li>
						<li>What you hear,</li>
						<li>What you want to understand,</li>
						<li>What you think you understand,</li>
						<li>What you understand,</li>
						</i></ol>
					<p><i>There are 10 possibilities that we may have some problem communicating. But let’s try anyway!”</i></p>
					<p><b>Bernard Werber</b></p>
				</div>


				<h3>Feedback on your 3 communication skills answers</h3>

				<IndividualQuestionFeedback number={1} questionId={'abcf1f5f-f928-442d-99f0-aaa301b9977f'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Because good communication leads to desired change. If people cannot follow you what you are saying, they are unlikely to do what you expect them to do. You are fully responsible for the other person’s understanding of what you are communicating.</ReactMarkdown>
				<ReactMarkdown>Always ask yourself, what do you most want them to understand? In other terms, what is your core message? Providing too much information is almost guaranteed to lose your audience – except if they have high levels of conscientiousness. Rather, you should stick to the most important information you want to provide, and be available to answer clarifying questions if necessary.</ReactMarkdown>

				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'3ff889da-9223-47e4-a171-c85003228c3b'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Because people need to feel heard and like they belong to bring their best contributions to the team. When people cannot openly speak their hearts and their minds, they will not be able to realize their potential.</ReactMarkdown>
				<ReactMarkdown>During many conversations, we are not truly listening to what the other person has to say, seeking to understand their perspective. Rather, we are waiting for them to finish so we can say our piece.</ReactMarkdown>
				<ReactMarkdown>However, when people feel they are being heard – which is rare – they will feel more closely connected to you, which will raise their trust and engagement levels.</ReactMarkdown>
				
				<div className="quote">
					<p><i>"Most people do not listen with the intent to understand; they listen with the intent to reply."</i></p>
					<p><b>Stephen Covey</b></p>
				</div>

				<div className="quote">
					<p><i>"If your mouth is open, you are not learning."</i></p>
					<p><b>Guatama Buddha</b></p>
				</div>

				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>
				<IndividualQuestionFeedback number={3} questionId={'4c4fcb2d-cdb7-42df-8b1b-91242fb6ad82'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Your body language and tone of voice may make or break your message. They can help to build trust, put people at ease just as much as they can confuse or upset people, therefore hurting their trust and your relationship.</ReactMarkdown>
				<ReactMarkdown>Here is an example: If you say “yes” while shaking your head no, your confused audience will have to decide between trusting your words or your behavior. They will likely choose to trust your body language, as nonverbal communication is more automatic and harder to fake.</ReactMarkdown>

				<div className="separator-large" />

				<h3>How you can grow your communication skills</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>
			

			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-7" className="offset-anchor">
				<div className="myimghor">
					<img src={leadershipimg} alt="People talking to each other" />
				</div>

				<h2>6. Your Leadership Skills</h2>

				<ReportPBar results={props.results} category={'Leadership'} num={6}/>

				<SkillResult category={'Leadership'} results={props.results}/>

				<h3>What are leadership skills?</h3>
				
				<ReactMarkdown>Leadership skills allow your people to do their best and to grow. When people feel like you have their interests at heart, they will truly want to work with you. Being a great leader means developing the leaders of tomorrow rather than seeking to be a ruler.</ReactMarkdown>
				<ReactMarkdown>Your guidance will help your people to focus on what matters to their contributions to their teams’ and organization’s missions.</ReactMarkdown>
				

				<h3>Feedback on your 3 leadership skills answers</h3>

				<IndividualQuestionFeedback number={1} questionId={'8cdc6af2-1c05-467f-8378-8b51614b5f5a'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>We all face challenges and setbacks. Sometimes, all we need to keep going is a little encouragement from someone we admire. Hearing someone saying, *“You can do it. I believe in you.”* can make all the difference. When we feel drained by the challenges we face, the right words can revitalize us.</ReactMarkdown>
				<ReactMarkdown>When we struggle or when we are stuck, we often fear other people’s judgement. Therefore, receiving encouragements delivers us hope, which gives us the strength to get back up and try again.</ReactMarkdown>

				<ReactMarkdown>The most admired leaders are **both demanding AND supportive**:</ReactMarkdown>
				<ul>
					<li>Their high standards help people rise to the occasion and accomplish things they would not have believed to be capable of.</li>
					<li>Their encouraging words refuel their people’s temporary loss of self-esteem and act as powerful motivators.</li>
				</ul>

				<ReactMarkdown>Meanwhile, the absence of one or the other is a recipe for disaster:</ReactMarkdown>
				<ul>
					<li>When you are not demanding enough, people may not dare try, which sabotages their progress or reduces their potential.</li>
					<li>When you are not supportive enough, people feel like they are not enough and that what they do is never good enough, which is highly demotivating.</li>
				</ul>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'d4a7f918-8503-4046-b78d-7d596620a401'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Difficult conversations are inevitable. When someone makes a mistake, negative emotions run high. As a result, many people tend to avoid talking about their mistakes. But that’s not the right answer. Rather, we need to learn how to have difficult conversations in a way which creates less pain for you and for the person you’re talking to, for the sake of the relationship.</ReactMarkdown>
				<ReactMarkdown>When you can speak up, therefore being vulnerable, and see that the other person tries to understand and help you, rather than admonish you, trust is built. Consideration and compassion will go a long way.</ReactMarkdown>
			
	
				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'6e32174f-a851-494b-ba1c-fd72abd0fd9e'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>The lessons we learn ourselves are the ones which have the greatest impact on our future behaviors. When you jump straight to telling people what they should do, you rob them from a teachable moment.</ReactMarkdown>
				<ReactMarkdown>This Socratic inquiry allows people to take an active role in their development, rather than being passive students which do as they are told, without thinking critically. </ReactMarkdown>
				<ReactMarkdown>You may be surprised by the ideas your people can imagine when you give them a space to reflect and to learn. Their ideas may complement or surpass yours.</ReactMarkdown>
				<ReactMarkdown>Finally, people feel more engaged with a solution they have actively participated in creating. They will be more intrinsically motivating in making the change happen.</ReactMarkdown>


				<div className="separator-large" />

				<h3>How you can grow your leadership skills</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>
			

			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-8" className="offset-anchor">
				<div className="myimghor">
					<img src={raisedhandsimg} alt="People talking to each other" />
				</div>

				<h2>7. Your Initiative Skills</h2>

				<ReportPBar results={props.results} category={'Initiative'} num={7}/>
				<SkillResult category={'Initiative'} results={props.results}/>

				<h3>What are initiative skills?</h3>
				
				<ReactMarkdown>Initiative describes your ability to speak up when something is wrong or when you find new – and hopefully better – ways of doing things.</ReactMarkdown>
				<ReactMarkdown>People and organizations need to both explore new opportunities as well as exploit what works well today. What got you here will not get you there.</ReactMarkdown>
				<ReactMarkdown>Taking charge means trusting yourself and asking questions, reading and listening to make the best decision you can for your situation.</ReactMarkdown>

				
				<div className="quote">
					<p><i>"In any moment of decision, the best thing you can do is the right thing, the next best thing is the wrong thing, and the worst thing you can do is nothing."</i></p>
					<p><b>Theodore Roosevelt</b></p>
				</div>


				<div className="separator-large" />

				<h3>Feedback on your 3 initiative skills answers</h3>

				<IndividualQuestionFeedback number={1} questionId={'deda25f2-7376-4b1b-880a-2e1bcec51644'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>High resistance to change can stifle innovation and the progress of an organization. Many people are reluctant to support change initiatives, because they are worried that the proposed solution is missing a critical information that can make it or break it.</ReactMarkdown>
				<ReactMarkdown>Therefore, it is important to make your voice be heard and make sure that the decision-makers have sufficient information to decide on the optimal path to take.</ReactMarkdown>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'4c1c62a7-c5a1-4f17-bdeb-89ed0f76acc3'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Sometimes, it’s better to ask for forgiveness than for permission. Taking calculated risks and testing new ideas is how people and organizations learn and grow. Making mistakes is human and therefore inevitable. What matters is to learn from our mistakes and to make sure others can learn from them as well.</ReactMarkdown>
				<ReactMarkdown>When people see that others get blamed, shamed, and reprimanded for their initiative efforts, they are less likely to dare trying themselves. As a result, the progress and learning from the entire company will suffer.</ReactMarkdown>

	
				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>
				<IndividualQuestionFeedback number={3} questionId={'c7043990-4c07-488f-b405-954abf20e7af'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>We can all stand on the shoulders of giants, by learning from what others before us have built, and by improving on their solutions. Our predecessors may have created the best solution they could conceive, based on the knowledge and technology that were available back then. This does not mean their solution is set in stone and cannot be improved upon.</ReactMarkdown>
				

				<div className="separator-large" />

				<h3>How you can grow your initiative skills</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>
			

			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-9" className="offset-anchor">
				<div className="myimghor">
					<img src={fingerprintsimg} alt="People talking to each other" />
				</div>

				<h2>8. Your Thoroughness Skills</h2>

				<ReportPBar results={props.results} category={'Thoroughness'} num={8}/>
				<SkillResult category={'Thoroughness'} results={props.results}/>

				<h3>What are thoroughness skills?</h3>
				
				<ReactMarkdown>Thoroughness describes your ability to think through the details with a critical eye and to focus on what really matters. For example, you provide accurate information in a useable form and on a timely basis to others who need to act on it.</ReactMarkdown>
				<ReactMarkdown>Thorough people tend to:</ReactMarkdown>
				
				<ul>
					<li>Maintain a checklist</li>
					<li>Schedule their tasks to make sure they don’t forget about them</li>
					<li>Follow policies and procedures</li>
					<li>Write down details to make sure they are not lost or forgotten</li>
					<li>Do work which requires less checking</li>
				</ul>


				<div className="separator-large" />

				<h3>Feedback on your 3 thoroughness skills answers</h3>

				<IndividualQuestionFeedback number={1} questionId={'79b95808-4ad0-48f3-9920-3fad46301952'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Paying attention to details allows you to notice mistakes others would not catch. This helps you to improve the productivity, efficiency, and performance of your teams and organizations. Your colleagues will appreciate your ability to prevent mistakes and will likely perceive you as being highly reliable.</ReactMarkdown>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'d42bfa7f-ef1c-4867-90e9-0c3616df21d3'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Uncertainty and lack of clarity are major causes of delays, frustrations and unnecessary conflicts. Your ability to know what you need to tackle, how and when to do it allow you to be a high performer.</ReactMarkdown>
				<ReactMarkdown>Being able to clarify your priorities with your leaders and teammates also allow you to make sure you are focusing your time and energy on what matters most to your teams and organization.</ReactMarkdown>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'99d45a46-c4f2-4e2b-b440-7607369d29e3'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Handing your work on time and with high standards of quality are clear signals that you are a reliable person. Reliability matters, because it’s one of the three elements which build trust between people.</ReactMarkdown>
				
				<section className="course-tables-center mt-4">
					<Card className="hover-increase" style={{ width: '18rem' }}>
						<Card.Img as={Image} src={likabilityexpertisereliability} variant="top" className="mb-3" />
						<Card.Title className="m-3">What are the 3 elements of trust?<Icon.ArrowRight className="ml-2" /></Card.Title>
						<a href="/elements-of-trust" className="stretched-link"></a>
					</Card>
				</section>
				

				<div className="separator-large" />

				<h3>How you can grow your thoroughness skills</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>


			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-10" className="offset-anchor">
				<div className="myimghor">
					<img src={expertiseimg} alt="People talking to each other" />
				</div>

				<h2>9. Your Expertise</h2>

				<ReportPBar results={props.results} category={'Expertise'} num={9}/>
				<SkillResult category={'Expertise'} results={props.results}/>

				<h3>What is expertise?</h3>
				
				<ReactMarkdown>Your expertise describes your ability to acquire and effectively use your technical knowledge, skills and judgement to accomplish results. Expertise matters, because it's one of the 3 elements of trust.</ReactMarkdown>

				<section className="course-tables-center mt-4">
					<Card className="hover-increase" style={{ width: '18rem' }}>
						<Card.Img as={Image} src={likabilityexpertisereliability} variant="top" className="mb-3" />
						<Card.Title className="m-3">What are the 3 elements of trust?<Icon.ArrowRight className="ml-2" /></Card.Title>
						<a href="/elements-of-trust" className="stretched-link"></a>
					</Card>
				</section>

				<div className="separator-large" />

				<h3>Feedback on your 3 expertise answers</h3>

				<IndividualQuestionFeedback number={1} questionId={'8c70aadb-e979-4780-8261-03f372bb7283'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Achieving results requires that *“people do everything they can to learn and deliver value at the same time, under the constant risk of failure.”*, as Alaric Bourgoin and Jean-Francois Harvey described in Harvard Business Review.</ReactMarkdown>
				<ReactMarkdown>For instance, you may select relevant pieces of information and share them with your people to guide their work. Another way is to learning from past assignments and sharing the lessons you’ve learned to help everyone’s learning efforts.</ReactMarkdown>
				

				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'af33084e-506f-4e71-9675-218e65198ebc'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Making yourself available to others to solve problems is key to building rapport and trust within the team. For instance, they may recognize and appreciate your tendency to keep up-to-date with the latest and greatest theories and practices in your field.</ReactMarkdown>
				

				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'7ceb6063-584b-4bb4-b201-b80cfed37ae2'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>You are likely going to be asked to contribute to projects as a subject matter expert, where people will have to trust your recommendations and act upon them. However, if they see others strongly question and challenge your knowledge, they will be less likely to follow you, and will seek for approvals by your manager or other experts before moving on.</ReactMarkdown>
				<ReactMarkdown>You don’t need to know everything right now, and you also should not pretend you do. When you don’t know the answer to a difficult question, admit it, promise you will look into it and walk the talk. During your next conversation on the topic, your research and preparation will allow you to answer said question, and the team will be able to move on to the next step of the project.</ReactMarkdown>
				

				<div className="separator-large" />

				<h3>How you can grow your expertise skills</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>


			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-11" className="offset-anchor">
				<div className="myimgvert">
					<img src={growthimg} alt="People talking to each other" />
				</div>

				<h2>10. Your Growth Mindset</h2>

				<ReportPBar results={props.results} category={'Growth Mindset'} num={10}/>
				<SkillResult category={'Growth Mindset'} results={props.results}/>

				<h3>What is a Growth Mindset?</h3>
				
				<ReactMarkdown>A growth mindset describes how you approach setbacks and learning.</ReactMarkdown>
				<ReactMarkdown>Having a growth mindset means:</ReactMarkdown>
				
				<ul>
					<li>Persisting in the face of setbacks</li>
					<li>Understanding failure as an opportunity to grow</li>
					<li>Prioritizing learning over seeking approval</li>
					<li>Confronting challenges to learn</li>
					<li>Focusing on the process instead of the end result</li>
				</ul>

				<ReactMarkdown>In contrast, having a fixed mindset means:</ReactMarkdown>

				<ul>
					<li>Giving up in the face of setbacks</li>
					<li>Understanding failure as the limit of your ability</li>
					<li>Seeking approval over learning</li>
					<li>Avoiding challenges</li>
					<li>Focusing on proving your self-worth</li>
				</ul>


				<div className="quote">
					<p><i>"A person’s true potential is unknown and unknowable."</i></p>
					<p><b>Carol S. Dweck</b></p>
				</div>

				<div className="quote">
					<p><i>"Whether you think you can or think you cannot, you are right."</i></p>
					<p><b>Henry Ford</b></p>
				</div>


				<div className="separator-large" />

				<h3>Feedback on your 3 growth mindset answers</h3>

				<IndividualQuestionFeedback number={1} questionId={'096a7e5e-5e3f-4462-94e3-55c463ea8233'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Behind each mistake lies a teachable moment. Although making and admitting your mistakes is painful, they can also become your best teachers.</ReactMarkdown>
				<ReactMarkdown>Learning from your mistakes means searching for ways to:</ReactMarkdown>
				
				<ul>
					<li>Preventing them from happening again</li>
					<li>Correcting them quickly and effectively should they still happen again</li>
					<li>Sharing the lesson you have learned with others, to contribute to your teams’ and organization’s learning</li>
				</ul>
				
				<div className="quote">
					<p><i>"A smart man makes a mistake, learns from it, and never makes that mistake again."</i></p>
					<p><b>Roy H. Williams</b></p>
				</div>

				<div className="quote">
					<p><i>"Mistakes can promote learning and be the basis of a deeper level of understanding."</i></p>
					<p><b>Thomas J. Wenzel</b></p>
				</div>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'19913602-ba56-40cf-b367-8e1ab558b36e'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<div className="quote">
					<p><i>"Errare humanum est."</i></p>
					<p><b>Seneca</b></p>
				</div>
				
				<ReactMarkdown>In the words of Seneca, making mistakes is human. We are imperfect, fallible beings and we will make wrong decisions from time to time.</ReactMarkdown>
				<ReactMarkdown>Even when the stakes are high - such as when developing a new drug or medical device – making mistakes is acceptable. What is unacceptable is not to learn from it. I once heard a senior leader say that making mistakes was unacceptable, which made many people uncomfortable. Why? Because they said they were now afraid they will be scolded for every single mistake they would make – no matter how big or small – since one of the most senior leaders said so. Make sure you do not do the same mistake he did.</ReactMarkdown>
				<ReactMarkdown>Why? Because your people will avoid situations in which they might make mistakes, for fear of being reprimanded. This will rob them from the experiences from which they are most likely to learn.</ReactMarkdown>

				<div className="quote">
					<p><i>"Fear of public failure is a powerful disincentive."</i></p>
					<p><b>Thomas J. Wenzel</b></p>
				</div>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'efcf9388-cd39-4e1c-a2b5-ae979b6a378a'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Brushing off your mistakes without reflecting from them will affect your long-term learning and development. As a result, you may achieve less in your career than you would wish.</ReactMarkdown>
				<ReactMarkdown>The next time you face a setback, ask yourself:</ReactMarkdown>

				<ul>
					<li>What was my intention?</li>
					<li>What went wrong?</li>
					<li>Why did it go wrong?</li>
					<li>When did it go wrong?</li>
					<li>What were the consequences?</li>
					<li>How can I prevent it from happening again?</li>
					<li>How can I correct it, should it happen again?</li>
				</ul>


				<div className="separator-large" />

				<h3>How you can grow your Growth Mindset</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>


			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-12" className="offset-anchor">
				<div className="myimghor">
					<img src={climbingimg} alt="People talking to each other" />
				</div>

				<h2>11. Your Drive For Results</h2>

				<ReportPBar results={props.results} category={'Drive for results'} num={11}/>
				<SkillResult category={'Drive for results'} results={props.results}/>

				<h3>What is a Drive for Results?</h3>
				
				<ReactMarkdown>Drive for results describes your desire to make your mark, which is demonstrated by your search for new challenges and opportunities. People with a high drive for results prioritize action above everything else, seeking to achieve their goals quickly and forcefully if necessary.</ReactMarkdown>
				<ReactMarkdown>They also prefer fast-paced environments, which means they appreciate people who get to the point quickly and efficiently. Nothing is more despicable to them than someone wasting their precious time.</ReactMarkdown>


				<div className="separator-large" />


				<h3>Feedback on your 3 drive for results answers</h3>

				<IndividualQuestionFeedback number={1} questionId={'5428308d-080a-4a2f-8a7c-0b468643a93a'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Today’s workplace is filled with distractions, which prevents many people from finishing what they start. As a result, your ability to see your tasks to completion makes you a valuable contributor.</ReactMarkdown>
				<ReactMarkdown>While others may become bored with their assignments and go above and beyond to be assigned to more interesting tasks, people with a drive for results stick with their challenges until they successfully overcome them. Because of their determination and persistence, they tend to be viewed as more reliable than others.</ReactMarkdown>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'bf38df98-a9fa-4eea-937e-286c40e72834'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Setting goals is key to achieving results. However, setting unrealistic or impossible goals kills other people’s motivation and engagement. Once they start believing that they are fighting a losing battle, they may stop trying or give up altogether.</ReactMarkdown>
				<ReactMarkdown>In contrast, when they believe they are making progress towards realistic and achievable objectives, people’s motivation and engagement soar. One way to do this is to break down your big objectives into smaller milestones that pave the way to the finish line. By being able to look back at what they’ve already achieved, and seeing how much still needs to be done, people are more likely to stay the course.</ReactMarkdown>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'d57f542f-179d-4bc5-9b0d-e2ab72547a10'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>When you demonstrate your high standard of performance to others, you act as a role model and may inspire them to do the same.</ReactMarkdown>
				<ReactMarkdown>In contrast, working for someone who expects too much from others, yet who produces sloppy work themselves is highly demotivating. We naturally dislike hypocrites and unfair people.</ReactMarkdown>
				<ReactMarkdown>When you set demanding goals to others, you give them the opportunity to rise to the occasion. People are often surprised to see what they can achieve, when they are encouraged and supported by a caring leader. This is the secret to great leadership: being both demanding AND supportive.</ReactMarkdown>


				<div className="separator-large" />

				<h3>How you can grow your Drive for Results</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>


			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-13" className="offset-anchor">
				<div className="myimghor">
					<img src={batteryimg} alt="People talking to each other" />
				</div>

				<h2>12. Your Energy Management Skills</h2>

				<ReportPBar results={props.results} category={'Energy management'} num={12}/>

				<SkillResult category={'Energy management'} results={props.results}/>

				<h3>What is Energy Management?</h3>
				
				<ReactMarkdown>While time management defines what you will do, when you will do it and for how long, energy management describes the quality of the work you will do.</ReactMarkdown>
				<ReactMarkdown>Energy management can be broken down into 4 dimensions:</ReactMarkdown>

				<ol>
					<li>Taking care of your health</li>
					<li>Soothing your emotions to avoid destructive behaviors</li>
					<li>Sharpening your focus on the task at hand</li>
					<li>Doing meaningful work which gives purpose to your life</li>
				</ol>
				

				<div className="separator-large" />


				<h3>Feedback on your 3 energy management answers</h3>

				<IndividualQuestionFeedback number={1} questionId={'799b7508-2f83-44f8-b6e0-a4198005feb4'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>There is only so much time and energy available per day. If you try to tackle too many things in a short period of time, you will exhaust your energy levels. Once the latter hits their limit, the quality of your work and of your relationships will tank.</ReactMarkdown>
				<ReactMarkdown>Such behaviors will have lasting damages over time:</ReactMarkdown>

				<ul>
					<li>Your health will suffer</li>
					<li>You will be prone to more negative emotions and emotional outbursts</li>
					<li>You will lose the ability to focus on your work</li>
					<li>You will feel like you are stuck in a life devoid of meaning</li>
				</ul>
				
				<ReactMarkdown>This can result in burnout, which can be grueling to recover from.</ReactMarkdown>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'61034909-df99-448a-acc5-53f66b93e85e'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<ReactMarkdown>People are not cold, efficient and unbreakable machines. We are social beings who need to feel safe and like others care about our well-being. When we do, we start building trust with each other.</ReactMarkdown>
				<ReactMarkdown>Some people are workaholics who have difficulties noticing the damages that overwork starts to have on their health, relationships, and lives. They need someone to tell them when they have done enough and deserve a break to recover their energy levels. Otherwise, they risk burning out, which will take away a valuable member of the team for reasons you could have prevented from happening.</ReactMarkdown>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'87fb48ce-50c2-44fe-bbf8-1d33be5707ff'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Staying mentally focused and emotionally sane is essential to doing your best work. When you are distracted, worried, angry, depressed or ashamed of something you have said or done, the quality of your efforts will suffer as well.</ReactMarkdown>
				<ReactMarkdown>Today’s pace of work is exhaustingly fast, which means you have to work hard to stay focused against the plethora of distractions, as well as emotionally sane against all the threats in your environment.</ReactMarkdown>

				
				<div className="separator-large" />

				<h3>How you can grow your Energy Management</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>


			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-14" className="offset-anchor">
				<div className="myimghor">
					<img src={feedbackimg} alt="People talking to each other" />
				</div>

				<h2>13. Your Openness to Feedback</h2>

				<ReportPBar results={props.results} category={'Openness to feedback'} num={13}/>
				<SkillResult category={'Openness to feedback'} results={props.results}/>

				<h3>What is Openness to Feedback?</h3>
				
				<ReactMarkdown>Openness to feedback describes your ability and willingness to ask for feedback from a broad range of sources, to consider the consequences of the information you receive and to act on it. What you do about this new information is what truly matters.</ReactMarkdown>
				<ReactMarkdown>The more open you are to feedback, the more coachable you are, and therefore, the more you can grow. Being truly and courageously open is what makes us human and therefore credible in the eyes of others.</ReactMarkdown>


				<div className="separator-large" />


				<h3>Feedback on your 3 Openness to Feedback answers</h3>

				<IndividualQuestionFeedback number={1} questionId={'fb41440b-8a0c-4636-8efd-316a787903d1'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Ideas need feedback. Without feedback, ideas will often stay unused or forgotten. Thanks to their previous experiences and own ideas, others may build on yours. Different perspectives can lead to better outcomes. For instance, they can imagine obstacles you did not consider, or more efficient ways to achieve your goals.</ReactMarkdown>
				<ReactMarkdown>When others know you think their opinion matters, they will likely trust you. When you include them, they will feel like they belong, which will strengthen your relationship.</ReactMarkdown>

				<div className="quote">
					<p><i>"Our core emotional need is to feel valued and valuable. When we don’t, it’s deeply unsettling, a challenge to our equilibrium, security, and well-being. At the most primal level, it can feel like a threat to our survival."</i></p>
					<p><b>Tony Schwartz</b></p>
				</div>				


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'dbc624f0-914a-48f6-aa58-89a6849e06e4'} feedbackByQuestion={props.results.feedbackByQuestion} />
				
				<ReactMarkdown>Working with people who are completely closed to suggestions is painful and demotivating. Remember, insecurity is usually what prompts bad behaviors.</ReactMarkdown>
				<ReactMarkdown>In psychology, **illusory superiority describes our tendency to overestimate our strengths and to overlook our faults**. Our personal hubris can sometimes lead to the fall of our enterprises, therefore hurting many other people. Know-it-alls are perceived as arrogant and are therefore kept out of the loop.</ReactMarkdown>
				<ReactMarkdown>Al Pittampalli, author of Persuadable, remarked that some of the greatest leaders demonstrated a willingness to consider emerging evidence and changed their behaviors accordingly. They listened attentively to new information and adjusted their predictions accordingly.</ReactMarkdown>
				<ReactMarkdown>When the boss comes in the room and says, “Here is what I think we should do. What do you think?”, she is killing any possibility of gathering constructive feedback. All she is likely to receive is approval, although people may think differently without daring to speak up.</ReactMarkdown>
				<ReactMarkdown>Ask what people think first, listen to their ideas, clarify any misunderstandings, compare with them your own intuitions and see how you can imagine a better solution together.</ReactMarkdown>

				<div className="quote">
					<p><i>"Be the last person to speak."</i></p>
					<p><b>Nelson Mandela</b></p>
				</div>	

				<div className="quote">
					<p><i>"The road to self-insight runs through other people."</i></p>
					<p><b>David Dunning</b></p>
				</div>	


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'7328e351-8503-4dfe-91f2-87fa477e1fb3'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Becoming more self-aware about your strengths, weaknesses, opportunities and threats to your career is only the first step. Self-development requires that you take action on this acquired knowledge and actively practice on the areas you want to improve about yourself.</ReactMarkdown>
				<ReactMarkdown>Creating a development plan takes some time upfront, but it wields great results over time, because it allows you to focus your time and energy on doing what truly matters and forgetting about the trivial activities which do not support you, your team or your organization.</ReactMarkdown>
				<ReactMarkdown>One of the best ways to make sure a new behavior becomes a habit is repeating it on a daily basis. For instance, you may take 15 minutes at the end of your day to reflect on what you’ve done, what you’ve learned, and how you could improve the way you do things tomorrow.</ReactMarkdown>
				

				<div className="separator-large" />

				<h3>How you can grow your Openness to Feedback</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>


			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-15" className="offset-anchor">
				<div className="myimghor">
					<img src={ovaluesimg} alt="People talking to each other" />
				</div>

				<h2>14. Your Purpose-Orientation</h2>
				<ReportPBar results={props.results} category={'Purpose'} num={14}/>
				<SkillResult category={'Purpose'} results={props.results}/>

				<h3>What is Purpose-Orientation?</h3>
				
				<ReactMarkdown>Having a purpose in life and feeling like you are realizing your potential has been identified by Abraham Maslow as the greatest source of motivation. It’s what drives you to do your best every day, to wake up with a desire to make a difference, and to go to bed with the satisfaction of what you have achieved that day.</ReactMarkdown>

				<div className="myimghor">
					<img src={maslowpyramid1img} alt="People talking to each other" />
				</div>

				<div className="imgcaption">
					Maslow's hierarchy of needs
				</div>
				

				<div className="separator-large" />


				<h3>Feedback on your 3 Purpose-Orientation answers</h3>

				<IndividualQuestionFeedback number={1} questionId={'3f9d268a-d533-4eb5-ae25-9ac23fc5ca80'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<div className="notabene">
					<ReactMarkdown>Having a purpose is a key motivator in life, because it gives meaning to your life and your efforts.</ReactMarkdown>
				</div>

				<ReactMarkdown>Why do you want to work for company A? One reason may be because of what it tries to achieve, how it tries to make a difference in the world. In other words, because of its mission.</ReactMarkdown>
				<ReactMarkdown>This attraction to a company’s mission and intentions is usually what draws us to apply for certain organizations and not others, and what motivates us in the beginning to do our best. Over time though, we may lose track of how your everyday efforts and struggles contribute to your organization’s mission. As a result, your motivation wanes.</ReactMarkdown>
				

				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>


				<IndividualQuestionFeedback number={2} questionId={'510bf8bb-3db1-4bbb-8968-7a928dabbb14'} feedbackByQuestion={props.results.feedbackByQuestion} />
				
				<ReactMarkdown>Reminding others about their purpose is just as important as reminding yourself about yours. To survive the busyness of our lives, we tend to do things on autopilot.</ReactMarkdown>
				<ReactMarkdown>The issue with losing sight of your purpose in life is that you will likely feel like what you are doing is meaningless – or worse, that your life is meaningless. We all need someone to remind us why we sacrifice our time and energy to keep going and keep growing.</ReactMarkdown>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'e04c03b1-907d-4f70-ab4e-40cf9f2cfe49'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Making a difference in the world is part of the 4 elements of Ikigai – living a life worth living – along with doing something you love, using your strengths, and being paid for your efforts.</ReactMarkdown>
				<ReactMarkdown>Because we are social and scient beings, we are motivated by the belief that our actions are helping improve the lives of people in the world – even those we do not know nor see – or to help keep the planet habitable for future generations.</ReactMarkdown>

				<section className="course-tables-center mt-4">
				<Card className="hover-increase" style={{ width: '18rem' }}>
					<Card.Img as={Image} src={teamworkimg} variant="top" className="mb-3" />
					<Card.Title className="m-3">Ikigai: What makes a life worth living<Icon.ArrowRight className="ml-2" /></Card.Title>
					<a href="/ikigai" className="stretched-link"></a>
				</Card>
				</section>


				<div className="separator-large" />

				<h3>How you can grow your Purpose-Orientation</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>


			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-16" className="offset-anchor">
				<div className="myimghor">
					<img src={emotionalityimg} alt="People talking to each other" />
				</div>

				<h2>15. Your Emotional Poise</h2>

				<ReportPBar results={props.results} category={'Emotional poise'} num={15}/>
				<SkillResult category={'Emotional poise'} results={props.results}/>

				<h3>What is Emotional Poise?</h3>
				
				<ReactMarkdown>Emotional poise describes your ability to soothe your emotions to prevent them from overwhelming you and those around you. It also means being empathic and compassionate towards how others are feeling.</ReactMarkdown>
				<ReactMarkdown>Knowing that your emotions are contagious and may affect others, you need to follow their guidance without letting them take over control.</ReactMarkdown>
				

				<div className="separator-large" />


				<h3>Feedback on your 3 Emotional Poise answers</h3>

				<IndividualQuestionFeedback number={1} questionId={'5ee3000c-efe8-4450-ba88-b7a655254c91'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<div className="notabene">
					<ReactMarkdown>Emotions are like the brain’s post-it notes: They make us pay attention to what is happening to us, because it helps our survival.</ReactMarkdown>
				</div>

				<ReactMarkdown>However, emotions can become counterproductive when they overwhelm us and prevent us from doing what needs to be done to solve the challenges we are facing.</ReactMarkdown>
				<ReactMarkdown>Being able to soothe your emotions is therefore a key strength when dealing with a crisis. Remaining calm and optimistic in the face of adversity will likely make you more resilient and will inspire others to support and follow you.</ReactMarkdown>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'f8addacc-a159-4850-b85b-6314d4359a44'} feedbackByQuestion={props.results.feedbackByQuestion} />
				
				<ReactMarkdown>Sharing your worries and sorrows is a great way to show vulnerability and grow stronger relationships with people who respond in a caring and supportive manner to your troubles. However, throwing a pity party for yourself on a regular basis or for trivial matters will likely sap morale.</ReactMarkdown>
				<ReactMarkdown>We all face doubts from time to time and need to know that others will be there to help us overcome them. When others feel like you cannot overcome yours and therefore help them overcome theirs, they will be less likely to come to you.</ReactMarkdown>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'e081b27c-a1a8-4f58-a759-07c724f8890e'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>Some people avoid having candid conversations, because of how they may make others feel uncomfortable, angry, sad, afraid or ashamed.</ReactMarkdown>
				<ReactMarkdown>However, having such conversations is essential to make sure your decisions will not harm others. For instance, adding features to your products may worsen your customers’ experience. Likewise, adding more to another team’s plate without aligning with them first will create resentment and negatively affect your relationship with them.</ReactMarkdown>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<h3>How you can grow your Emotional Poise</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>


			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>


			<section id="section-17" className="offset-anchor">
				<div className="myimghor">
					<img src={warmthimg} alt="People talking to each other" />
				</div>

				<h2>16. Your Trust-Building</h2>
				<ReportPBar results={props.results} category={'Trust building'} num={16}/>
				<SkillResult category={'Trust building'} results={props.results}/>

				<h3>What is Trust-Building?</h3>
				
				<ReactMarkdown>Building trust is the most important skill of all, because trust is the foundation upon which team performance is built. In one way or another, the other 15 skills enable you to be perceived by others as a trustworthy person.</ReactMarkdown>
				
				<div className="myimghor">
					<img src={fivebehaviorsimg} alt="People talking to each other" />
				</div>

				<div className="imgcaption">
					Adapted from "The 5 behaviors of a cohesive team" by Patrick Lencioni
				</div>
				

				<section className="course-tables-center mt-4">
					<Card className="hover-increase" style={{ width: '18rem' }}>
						<Card.Img as={Image} src={likabilityexpertisereliability} variant="top" className="mb-3" />
						<Card.Title className="m-3">What are the 3 elements of trust?<Icon.ArrowRight className="ml-2" /></Card.Title>
						<a href="/elements-of-trust" className="stretched-link"></a>
					</Card>
				</section>

				<div className="separator-large" />


				<h3>Feedback on your 3 Trust-Building Answers</h3>

				<IndividualQuestionFeedback number={1} questionId={'d242e8b6-6222-4af4-9116-c09e7fb9c629'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>As we have seen in other skills, people crave for belonging to a tribe and like their voices are being heard. When people can talk openly and with vulnerability about their issues or concerns, knowing that you will care and try to help them, trust is built.</ReactMarkdown>
				

				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={2} questionId={'0489df5f-b61c-4111-a780-fef7aa257901'} feedbackByQuestion={props.results.feedbackByQuestion} />
				
				<ReactMarkdown>Active listening means seeking to understand what the other person is trying to communicate. Real conversations require that each person participating in them tries to understand what the others are saying, and tries to contribute to improving the discussed ideas.</ReactMarkdown>
				<ReactMarkdown>Too often, we tend to interrupt others because we believe what we have to say is more interesting or more important that what the other person is saying. This is what Stephen Covey meant by “listening with the intent to reply” rather than with the intent to understand.</ReactMarkdown>

				<div className="quote">
					<ReactMarkdown className="quote-p">Do not assume. Because when you **ASSUME**, you make an **ASS** of **U** and **ME**.</ReactMarkdown>
				</div>

				<ReactMarkdown>Rather, ask clarifying questions and see if you truly understand the message the other person is trying to share with you.</ReactMarkdown>


				<div className="dot-container my-5">
					<Icon.Dot className="dot" />
				</div>

				<IndividualQuestionFeedback number={3} questionId={'ffcfe058-5a31-40bd-baf7-228d50723c9a'} feedbackByQuestion={props.results.feedbackByQuestion} />

				<h4>Why it matters</h4>
				<ReactMarkdown>When someone recognizes that what we have done has helped the team make progress, we feel valued. When they do, we feel like we are receiving confirmation that our efforts are desirable and worth something to them.</ReactMarkdown>
				<ReactMarkdown>The American Psychological Association (APA) published interesting results linking feeling valued with positive effects such as:</ReactMarkdown>

				<ul>
					<li>Feeling more engaged and satisfied</li>
					<li>Feeling more motivated</li>
					<li>Reporting better mental and physical health</li>
				</ul>

				<div className="myimghor">
					<img src={feelingvaluedimg} alt="People talking to each other" />
				</div>

				<div className="imgcaption">
					People who feel valued become more loyal to you.
				</div>


				<div className="separator-large" />

				<h3>How you can build trust</h3>
				<ReactMarkdown>This section is still being developed. Please come back later!</ReactMarkdown>
			</section>


			<div className="dot-container my-5">
				<Icon.Dot className="dot" /><Icon.Dot className="dot" /><Icon.Dot className="dot" />
			</div>
			

			<section id="section-6" className="offset-anchor">


                <div className="content-btn-box">
                    <a href="/ei-course" className="content-btn">Back to the course <Icon.ArrowRight className="ml-2" /></a>
                </div>
			<br /><br /><br />
			</section>
		</body>
   </div>
  )
}
export default ThreeSixtyFeedbackContent;

